import Swiper from "swiper/bundle";

export default class MultiCarousel {
  constructor(element, extraOptionsFirst, extraOptionsSecond) {
    this.element = element;
    this.swiperElements = this.element.querySelectorAll(".swiper");
    this.swiperButtonPrev = this.element.querySelector(".swiper-button-prev");
    this.swiperButtonNext = this.element.querySelector(".swiper-button-next");

    this.defaultOptions = {
      slidesPerView: "auto",
      grabCursor: true,
      lazy: true,
      mousewheel: {
        forceToAxis: true,
      },
      controller: {
        inverse: true,
        by: "container",
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 24,
        },
      },
    };

    this.topSwiper = new Swiper(this.swiperElements[0], {
      ...this.defaultOptions,
      ...extraOptionsFirst,
    });

    this.bottomSwiper = new Swiper(this.swiperElements[1], {
      ...this.defaultOptions,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      ...extraOptionsSecond,
    });

    this.topSwiper.controller.control = this.bottomSwiper;
    this.bottomSwiper.controller.control = this.topSwiper;

    this.addObserver();
  }

  addObserver() {
    this.swiperObserver = new IntersectionObserver((entries) => this.slideAndAutoplay(entries), { rootMargin: "0px", threshold: 0.75 });
    this.swiperObserver.observe(this.element);
  }

  slideAndAutoplay(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const duration = window.matchMedia("(min-width: 767.98px)").matches ? 1500 : 2500;

        this.bottomSwiper.slideTo(0, duration);
        this.bottomSwiper.params.autoplay.delay = 5000;
        this.bottomSwiper.update();
        this.bottomSwiper.autoplay.disableOnInteraction = true;
        this.bottomSwiper.autoplay.start();
        this.swiperObserver.disconnect();
      }
    });
  }
}
